module.exports = __webpack_public_path__ + "static/logo-principal-2-rb-e82b53a3cf4b7d40d388fb6c77306625.png";